// Extraído de PeticionDetail.jsx (refactor mecánico, sin cambios funcionales)
import React, { useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { Pencil } from "lucide-react";
import { ProyectoThumb } from "@/components/ProyectoThumb";

// Imagen del proyecto en la cabecera (subida rápida sin abrir el diálogo de edición)
export function HeaderImagen({ p, cli, onSaved }) {
  const inputRef = React.useRef(null);
  const [uploading, setUploading] = useState(false);
  const onFile = async (e) => {
    const file = e.target.files?.[0];
    e.target.value = "";
    if (!file) return;
    setUploading(true);
    try {
      const { uploadToCloudinary } = await import("@/lib/cloudinary");
      const { secure_url } = await uploadToCloudinary(file, "dnf/peticiones");
      await api.patch(`/peticiones/${p.id}`, { imagen_url: secure_url });
      toast.success("Imagen del proyecto actualizada");
      onSaved && onSaved();
    } catch (err) {
      toast.error("Error subiendo imagen: " + (err?.message || ""));
    } finally { setUploading(false); }
  };
  return (
    <div className="relative shrink-0 group">
      <ProyectoThumb url={p.imagen_url} nombre={cli?.nombre || p.nombre} size={64} rounded="lg"
        data-testid="peticion-header-imagen" />
      <button type="button" onClick={() => inputRef.current?.click()} disabled={uploading}
        data-testid="peticion-header-imagen-edit"
        title={p.imagen_url ? "Cambiar imagen del proyecto" : "Añadir imagen del proyecto"}
        className="absolute -bottom-1.5 -right-1.5 bg-zinc-800 hover:bg-zinc-700 border border-zinc-600 rounded-full p-1.5 text-zinc-300 transition-colors shadow">
        {uploading
          ? <span className="block w-3 h-3 border-2 border-amber-400 border-t-transparent rounded-full animate-spin" />
          : <Pencil className="w-3 h-3" />}
      </button>
      <input ref={inputRef} type="file" accept="image/*" className="hidden" onChange={onFile} />
    </div>
  );
}
